<template>
  <!-- 导航开始 -->
  <div class='commonClientinfoAttachment' :class="{scrollHide: isShowStoreBox}" ref="scrollBox">

    <div class="lis" v-for="(app,index) in data" :key="index">
      <div class="imgBox">
        <i v-if="app.id===1" class="iconfont icon-pdf"></i>
        <i v-else class="iconfont icon-zip"></i>
      </div>
      <div class="mainBox">
        <h3>
          {{app.topic}}
          <span @click="storeBoxFun(true,2,app.id)" class="btn btn-secondary btn-sm animated animated4 fadeIn">改</span>
        </h3>
        <div>
          {{app.contents}}
        </div>
        <div class="msg" style="margin: 0;">
          <a v-if="(app.filepath).substring((app.filepath).lastIndexOf('.')+1)!=='pdf'" :href="app.filepath" class="badge badge-info"><i class="iconfont icon-xiazai-"></i> 附件下载</a>
          <a v-else target="_blank" :href="app.filepath" class="badge badge-info"><i class="iconfont icon-file"></i> 打开pdf</a>
        </div>
      </div>
    </div>
    <div v-if="!is_empty">
      <div v-if='isLoading && !isSearchLoading' class='dynamicMessage'>
        <i class='iconfont icon-jiazai xuanzhuan'></i>
      </div>
      <div v-if='isNodata' class='dynamicMessage'>
        — 没有更多了 —
      </div>
      <div v-if='isError' class='dynamicMessage'>
        — 请求失败 —
      </div>
    </div>
    <div class="emptyBox" v-if="is_empty && data.length===0">
      <i class="iconfont icon-kong"></i>
    </div>
    <div v-if="isShowStoreBox" class="traceStoreBoxModel">
      <div class="traceStoreBox">
        <div class="xuanzeBox mb-3">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">文件标题</span>
              </div>
              <input type="text" v-model="topicVal" class="form-control">
            </div>
        </div>

        <div class="biaodanBox mb-3">
          <uploader :options="options" @file-added="onFileAdded" @file-success="onFileSuccess" @file-error="onFileError" @file-removed="fileRemoved">
            <uploader-btn class="clearCss" :attrs="attrs">
              <div class="uploadBox">
                <div :class="{'text-success':!!filename}" v-if="!isUploadLoading">{{filename?filename:'【上传附件】'}}</div>
                <div v-else><i class='iconfont icon-jiazai xuanzhuan'></i> 上传中···</div>
              </div>
            </uploader-btn>
          </uploader>
        </div>

        <p class="content">注：PDF / 压缩包</p>

        <div class="textareaBox mb-3">
          <textarea class="form-control" aria-label="With textarea" v-model="contentsVal" placeholder="描述"></textarea>
        </div>
        <div class="anniuBox">
          <button type="button" @click.self="storeBoxFun(false)" class="btn btn-secondary btn-round">取消</button>
          <button type="button" v-if="btnTitle==='修改'" @click="submitDelFun()" class="btn btn-danger btn-round">
            <i v-if="isDelLoading" class='iconfont icon-jiazai xuanzhuan'></i> 删除
          </button>
          <button type="button" @click="submitFun()" class="btn btn-success btn-round">
            <i v-if="isSubmitLoading" class='iconfont icon-jiazai xuanzhuan'></i> {{btnTitle}}
          </button>
        </div>
      </div>
    </div>
    <span v-if="!isShowStoreBox" @click="storeBoxFun(true,1)" class="tianjia btn btn-success btn-round">添加</span>
    <div class="searchLoadingBox" v-if="isSearchLoading">
      <span>
        <i class='iconfont icon-jiazai xuanzhuan'></i>
      </span>
    </div>
  </div>
  <!-- 导航结束 -->
</template>

<script>
import { mapGetters } from 'vuex';
import * as types from '@/store/types';
import resultCommons from '@/util/resultcommons';
import { EventBus } from '@/util/eventBus';

export default {
  name: 'commonClientinfoAttachment',
  props: ['token'],
  data() {
    return {
      isUploadLoading: false,
      filepath: '',
      filename: '',
      attrs: {
        accept: 'application/x-gzip,application/zip,application/rar,application/x-tar,application/pdf',
      },

      isShowStoreBox: false,
      isSubmitLoading: false,
      isDelLoading: false,
      btnTitle: '',
      // 备忘队列
      memoData: [
        { id: 1, times: '2021-22-56 12:12:25', title: '这是一个备忘', content: '这是备注这是备注这是备注这是备注这是备注这是备注这是备注这是备注这是备注' },
      ],
      // 合同标题
      topicVal: '',
      // 合同备注
      contentsVal: '',
      str: '',

      // 分页
      data: [], // 数据队列
      allPage: 0, // 总页数
      allNumber: 0, // 总页数
      page: 1, // 当前页数
      is_empty: false, // 是否为空数据(没有任何数据)
      isNodata: false, // 没有更多了
      isLoading: false, // 是否请求中
      isError: false, // 请求失败
      // 加载中
      isSearchLoading: true,
    };
  },
  computed: {
    ...mapGetters({
      localUser: types.GET_LOCALUSER,
    }),
    options() {
      return {
        target: process.env.IMAGE_UPLOAD_URL,
        testChunks: false,
        singleFile: true,
        chunkSize: 200 * 1024 * 1024,
        fileParameterName: 'UploadFormfile[imgFile]',
        query: {
          dir: 'crmfiles',
        },
        headers: {
          Authorization: this.localUser.token,
          Version: this.localUser.version,
        },
      };
    },
    submitData() {
      return {
        filename: this.filename,
        filepath: this.filepath,
        token: this.token,
        topic: this.topicVal,
        contents: this.contentsVal,
        str: this.str,
      };
    },
  },
  methods: {
    onFileAdded(file) {
      // 判断文件大小
      const size = file.file.size;
      if (size > process.env.IMAGE_UPLOAD_SIZE) {
        file.pause();
        this.$message.showMsgBox({
          type: 'success',
          content: '文件过大',
        });
      }
    },
    onFileSuccess(rootFile, file, response, chunk) {
      // 上传选择后
      const result = JSON.parse(response);
      if (result.state === 200) {
        this.filepath = result.data.path;
        this.filename = result.data.name;
        this.$message.showMsgBox({
          type: 'success',
          content: '上传成功',
        });
      } else {
        this.$message.showMsgBox({
          type: 'error',
          content: result.message,
        });
      }
      this.isUploadLoading = false;
    },
    onFileError(file) {
      console.log(file, 'onFileError');
      // 上传选择后
      this.$message.showMsgBox({
        type: 'error',
        content: '上传失败',
      });
    },
    fileRemoved(file) {
      console.log(file, 'fileRemoved');
    },
    storeBoxFun(bool, type, str = '') {
      this.isShowStoreBox = bool;
      // 如果显示模态框
      if (bool) {
        // 添加
        if (type === 1) {
          this.topicVal = '';
          this.contentsVal = '';
          this.str = '';
          this.btnTitle = '添加';
          this.filepath = '';
          this.filename = '';
        }
        // 修改
        if (type === 2) {
          const info = this.data.find(app => app.id === str);
          this.topicVal = info.topic;
          this.contentsVal = info.contents;
          this.str = str;
          this.btnTitle = '修改';
          const fileInfo = new URL(info.filepath);
          this.filepath = fileInfo.pathname;
          this.filename = info.filename;
        }
      } else {
        this.str = '';
        this.btnTitle = '';
      }
    },
    // 状态切换
    loadingFun(bool) {
      if (bool === 1) {
        // 加载中
        this.isNodata = false;
        this.isError = false;
        this.isLoading = true;
      } else if (bool === 2) {
        // 关闭所有
        this.isNodata = false;
        this.isError = false;
        this.isLoading = false;
        this.isSearchLoading = false; // 悬浮加载中
      } else if (bool === 3) {
        // 没有更多了
        this.isNodata = true;
        this.isError = false;
        this.isLoading = false;
        this.isSearchLoading = false; // 悬浮加载中
      } else {
        // 请求失败了
        this.isNodata = false;
        this.isError = true;
        this.isLoading = false;
        this.isSearchLoading = false; // 悬浮加载中
      }
    },
    // 初始化个人的
    initData(reload = false) {
      if (reload) {
        this.data = [];
        this.allPage = 0;
        this.page = 1;
        this.allNumber = 0;
        this.is_empty = false; // 是否为空数据(没有任何数据)
        this.isNodata = false; // 没有更多了
        this.isLoading = false; // 是否请求中
        this.isError = false; // 请求失败
        this.isSearchLoading = true; // 悬浮加载中
      }
      return resultCommons.apiCrmFiles(this, { page: this.page, token: this.token }, reload).then((ob) => {});
    },
    scroll(that, node) {
      node.onscroll = () => {
        // 距离底部200px时加载一次
        const bottomOfWindow = node.scrollHeight - node.scrollTop - node.clientHeight <= 150;
        console.log(bottomOfWindow);
        // 距离200像素时 & 可以请求时 & 页码小于等于最大页码时 & !没有更多时 & !空数据时
        if (bottomOfWindow && that.isLoading === false && !that.isNodata && !that.isError && !that.is_empty) {
          this.initData();
        }
      };
    },
    submitFun() {
      // 遮罩
      EventBus.$emit('globalZhezhaoBoxFun', true);
      // 提交中
      this.isSubmitLoading = true;
      resultCommons.apiCrmFilesStore(this, this.submitData).then((ob) => {
        // 遮罩
        EventBus.$emit('globalZhezhaoBoxFun', false);
        // 提交中
        this.isSubmitLoading = false;
        if (ob.state === 200) {
          const info = ob.data.info;
          if (ob.data.type === 'join') {
            // 加入
            this.data.unshift(info);
          } else {
            // 更新
            this.data.forEach((app, index) => {
              if (app.id === info.id) {
                this.data[index] = info;
              }
            });
          }
          // 隐藏box
          this.isShowStoreBox = false;
          // 提示
          this.$message.showMsgBox({
            type: 'success',
            content: ob.message,
          });
        } else {
          // 提示
          this.$message.showMsgBox({
            type: 'warning',
            content: ob.message,
          });
        }
      });
    },
    submitDelFun() {
      // 遮罩
      EventBus.$emit('globalZhezhaoBoxFun', true);
      // 提交中
      this.isDelLoading = true;

      // 执行删除
      resultCommons.apiCrmFilesDel(this, { str: this.str }).then((ob) => {
        // 遮罩
        EventBus.$emit('globalZhezhaoBoxFun', false);
        // 提交中
        this.isDelLoading = false;
        if (ob.state === 200) {
          // 隐藏box
          this.isShowStoreBox = false;
          this.data = this.data.filter(app => app.id !== this.str);
          this.$message.showMsgBox({ type: 'success', content: ob.message });
        } else {
          this.$message.showMsgBox({ type: 'warning', content: ob.message });
        }
      });
    },
  },
  components: {
  },
  created() {
    // 初始化
    this.initData().then((app) => {
      this.isSearchLoading = false;
    });
  },
  mounted() {
    // 创建事件
    this.scroll(this, this.$refs.scrollBox);
  },
  destroyed() {
  },
};
</script>

<style scoped lang='less'>
.commonClientinfoAttachment{
  flex: 1;
  overflow-y: auto;
  background: #FFFFFF;
  padding: 15px;
  div.emptyBox{
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100%;
    i{
      font-size: 70px;
      color: rgba(0,0,0,0.1);
    }
  }
  div.lis{
    display: flex;
    margin-bottom: 15px;
    border-bottom: 1px dashed rgba(0,0,0,0.2);
    div.imgBox{
      margin-right: 10px;
      width: 60px;
      height: 60px;
      background: #343A40;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #FFFFFF;
      i{
        font-size: 22px;
      }
    }
    div.mainBox{
      flex: 1;
      margin-top: 3px;
      margin-bottom: 15px;
      h3{
        font-size: 16px;
        span{
          float: right;
          font-family: 'gilroy-extrabold';
          display: none;
          font-size: 12px;
          border-radius: 4px;
          font-weight: 300;
          padding: 0;
          padding:0px 2px;
          padding-left: 3px;
        }
      }
      div{
        color: #999999;
      }
      div.msg{
        a{
          i{
            font-size: 13px;
          }
        }
      }
    }
    &:hover{
      div.mainBox{
        h3{
          span{
            display: block;
          }
        }
      }
    }
  }
  span.tianjia{
    position: absolute;
    display: inline-block;
    width: 90px;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    margin-bottom: 20px;
    text-align: center;
    box-shadow: 0 0 1rem rgba(0, 0, 0, 0.2);
  }
  div.traceStoreBoxModel{
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0,0,0,0.1);
    backdrop-filter: blur(5px);
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    div.traceStoreBox{
      justify-content: center;
      align-items: center;
      box-shadow: 0 0 1rem rgba(0, 0, 0, 0.2);
      padding: 30px 15px;
      background: #FFFFFF;
      div.xuanzeBox{
        display: flex;
        flex-direction: row;
        div.box{
          margin-right: 6px;
          flex: 1;
          position: relative;
        }
        div.last{
          flex: 1;
          display: flex;
          align-items: center;
          margin: 0;
          div.form-group{
            margin: 0;
            .form-check{
              margin: 0;
            }
          }
        }
      }
      div.textareaBox{
        textarea{
          height: 90px;
          border-radius: 5px;
        }
      }
      div.anniuBox{
        text-align: right;
      }
    }
  }
  div.mainBox{
    margin-bottom: 10px;
    .media{
      div.head{
        width: 100px !important;
        height: 100px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/clientinfo/attachment.vue